module.exports = __webpack_public_path__ + "img/e_2_12_r.d253218a.png";